import { Component, inject, type OnInit, signal, type WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MaloupeEventName } from '@malou-io/package-utils';

import { EquipHotelRankingComponent } from ':modules/restaurant-diagnostic-events/equip-hotel-ranking/equip-hotel-ranking.component';
import { EventRankingComponent } from ':modules/restaurant-diagnostic-events/event-ranking/event-ranking.component';

@Component({
    selector: 'app-restaurant-diagnostic-event',
    templateUrl: './restaurant-diagnostic-event.component.html',
    styleUrl: './restaurant-diagnostic-event.component.scss',
    imports: [EquipHotelRankingComponent, EventRankingComponent],
})
export class RestaurantDiagnosticEventComponent implements OnInit {
    private readonly _router = inject(Router);
    private readonly _activatedRoute = inject(ActivatedRoute);

    readonly MaloupeEventName = MaloupeEventName;
    readonly eventName: WritableSignal<MaloupeEventName | null> = signal(null);

    ngOnInit(): void {
        this._activatedRoute.queryParamMap.subscribe((params) => {
            const event = params.get('event_name');
            if (event) {
                const isValidEvent = Object.values(MaloupeEventName).includes(event as MaloupeEventName);
                if (!isValidEvent) {
                    this._router.navigate(['/']);
                }
                this.eventName.set(event as MaloupeEventName);
            }
        });
    }
}
